import { Card, CardContent, Container, Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Suspense, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useGetAccountsQuery } from '../../../api/recalc/endpoints/accountsApiSlice';
import { getSelectedAccount } from '../../../redux/selectedAccountSlice';
import AccountDrawerContainer from './AccountDrawerContainer';
import ServiceManagementDatagrid from '@/features/service-management/components/ServiceManagementDatagrid';

const ServiceManagementPage = () => {
  const [selectedRow, setSelectedRow] = useState({});
  const selectedAccount = useSelector(getSelectedAccount);

  const { data: accounts, isFetching } = useGetAccountsQuery();
  useEffect(() => {
    if (accounts) {
      setSelectedRow((prev) => {
        let account = {};
        if (prev && prev?.AccountId)
          account = accounts.find((a) => a.AccountId === prev.AccountId);
        return account;
      });
    }
  }, [accounts]);
  return (
    <Container maxWidth="xxl">
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              verticalAlign: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <Box sx={{ display: 'flex', height: '70vh', width: '100%' }}>
          <Grid container spacing={2}>
            {[
              {
                label: 'Basis',
                name: 'Basis',
                path: '/service-management/Basis',
              },
              { label: 'PVO', name: 'PVO', path: '/operations' },
              {
                label: 'EnergyXplorer',
                name: 'EnergyXplorer',
                path: '/service-management/energyxplorer',
              },
              {
                label: 'Portfolio Analysis',
                name: 'PortfolioAnalysis',
                path: '/service-management/portfolio-analysis',
              },
            ].map((service, index) => (
              <Grid key={index} item lg={3}>
                <ServiceCard {...service} accounts={accounts} />
              </Grid>
            ))}
            <Grid item lg={12} height={'80vh'}>
              <ServiceManagementDatagrid
                initialRows={accounts?.map((account) => {
                  return {
                    ...account,
                    id: account.AccountId,
                  };
                })}
                isLoading={isFetching}
                setSelectedRow={setSelectedRow}
                account={selectedAccount}
              />
            </Grid>
          </Grid>
        </Box>
      </Suspense>
      <AccountDrawerContainer
        isOpen={!!selectedRow?.Name}
        onClose={() => setSelectedRow({})}
        account={selectedRow}
      />
    </Container>
  );
};

export default ServiceManagementPage;

const ServiceCard = (props) => {
  const { name, label = name, accounts = [], path } = props;
  const serviceCount = useMemo(() => {
    return accounts.reduce((acc, account) => {
      if (account.Services.some((s) => s.Name === name)) return acc + 1;
      return acc;
    }, 0);
  }, [name, accounts]);
  return (
    <Card variant="outlined">
      <Link to={`${path}`}>
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              mb: 2,
            }}
          >
            <Typography variant="body1" color="textSecondary" fontWeight="bold">
              {label}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" color="textPrimary" fontWeight={'bold'}>
                {serviceCount}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Link>
    </Card>
  );
};
